{
  "projects.archive.restore": "Projeyi geri yükle",
  "projects.trash.title": "“{{title}}” Çöp’e taşınsın mı?",
  "projects.trash.description": "Proje etkin ve arşiv görünümlerinden çıkar; geri yükleme veya ayrıca onaylanan kalıcı silme için Çöp’te kalır.",
  "projects.trash.action": "Çöp’e taşı",
  "projects.records.trashTitle": "“{{title}}” Çöp’e taşınsın mı?",
  "projects.records.trashGoalDescription": "Arşivlenmiş hedef, geri yükleme veya ayrıca onaylanan kalıcı silme için Çöp’te kalır.",
  "projects.records.trashDecisionDescription": "Arşivlenmiş karar ve seçenekleri, geri yükleme veya ayrıca onaylanan kalıcı silme için Çöp’e birlikte taşınır.",
  "projects.records.trashAction": "Çöp’e taşı",
  "projects.records.trashError": "Kayıt Çöp’e taşınamadı. Tekrar deneyin.",
  "projects.options.title": "Karar seçenekleri",
  "projects.options.description": "Alternatifleri saklayın ve gerekçenin daha sonra anlaşılması için en fazla birini seçilmiş olarak işaretleyin.",
  "projects.options.add": "Seçenek ekle",
  "projects.options.empty": "Henüz bir alternatif kaydedilmedi.",
  "projects.options.selected": "Seçildi",
  "projects.options.editLabel": "{{title}} seçeneğini düzenle",
  "projects.options.deleteLabel": "{{title}} seçeneğini kaldır",
  "projects.options.field.title": "Seçenek başlığı",
  "projects.options.field.description": "Bu seçenekle ilgili notlar",
  "projects.options.field.selected": "Seçilmiş olarak işaretle",
  "projects.options.field.selectedHint": "Bu seçeneği işaretlemek önceki seçimi otomatik olarak kaldırır.",
  "projects.options.cancel": "Vazgeç",
  "projects.options.save": "Seçeneği kaydet",
  "projects.options.titleRequired": "Bir seçenek başlığı girin.",
  "projects.options.saveError": "Seçenek kaydedilemedi. Tekrar deneyin.",
  "projects.options.deleteTitle": "“{{title}}” kalıcı olarak kaldırılsın mı?",
  "projects.options.deleteDescription": "Yalnızca bu seçenek kaldırılır; karar kalır. Bu seçenek Çöp’e gönderilmez ve geri yüklenemez.",
  "projects.options.deleteAction": "Kalıcı olarak kaldır",
  "projects.options.deleteError": "Seçenek kaldırılamadı. Tekrar deneyin."
}
